import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class SimulatorCacheService {
  private hasSimulated: BehaviorSubject<boolean> = new BehaviorSubject(false);

  constructor() {}

  getHasSimulated() {
    return this.hasSimulated;
  }

  setHasSimulated(hasSimulated) {
    this.hasSimulated.next(hasSimulated);
  }
}
